export default __webpack_public_path__ + "static/media/2_slide.e3a91bcf.png";